import styled from 'styled-components'
import Modal from 'styled-react-modal'

import colors from '@settings/styleSettings'

export const ModalContainer = Modal.styled`
  width: 384px;
  background-color: ${colors.background};
  border-radius: 8px;
  padding:24px;

  @media (max-width: 450px) {
    width: 300px;
    padding: 12px;
  }

  @media (max-width: 350px) {
    width:250px;
    padding: 12px;
  }

`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
`

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InfoIcon = styled.div`
  width: 24px;
  height: 24px;
  color: ${colors.strongGray};
`

export const Title = styled.div`
  font-family: Circular-Std-Bold;
  font-weight: 700;
  font-size: 24px;
  align-self: center;

  @media (max-width: 450px) {
    font-size: 20px;
  }
`

export const Text = styled.div`
  color: ${colors.strongGray};
  font-size: inherit;
  font-family: Circular-Std-Bold;
  font-weight: 500;
  margin-top: 18px;
  text-align: center;
  padding-bottom: 10px;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  left: 90%;
  color: ${colors.strongGray};
`

export const CheckBoxContainer = styled.div`
  font-family: Circular-Std;
  display: flex;
  flex-direction: column;
  margin: 0 0 0 12px;
  gap: 22px;
  font-size: 20px;

  @media (max-width: 450px) {
    font-size: 14px;
  }
`
